import '../../common_screen/contest_tab/index_web.css';
import React from 'react';
import { AddCashModal, View } from '../../../component';
import {
  ContestConfirmModal,
  ContestFilter,
  ContestListHeader,
  ContestShare,
  ContestSortingHeader
} from '../../component';
import ContestCardWeb from '../../component/contest_card/index_web';

const ContestListTabWeb = ({
  onPressFilter,
  onPressEntryFee,
  onPressPrizePool,
  onPressSpots,
  onPressCard,
  onPressShare,
  contestCategoryList,
  matchStatus,
  gameState,
  totalTeamsCount,
  matchItem,
  matchDelayed,
  gameType,
  onApplyFilter,
  onClearFilter,
  contestFilterVisible,
  onPressFilterDismiss,
  contestLink,
  contestTitle,
  contestShare,
  onPressShareModalDismiss,
  showAllContest,
  onPressJoinContest,
  onPressJoin,
  onPressWinners,
  contestConfirmModal,
  onPressDismissContestConfirm,
  entryFee,
  bonusPercentage,
  balance,
  addCashVisible,
  onPressDismissCashModal
}: any) => {
  return (
    <>
      <div className="contestTab__SortingHeaderWrapper__web">
        <ContestSortingHeader
          onPressFilter={onPressFilter}
          onPressEntryFee={onPressEntryFee}
          onPressPrizePool={onPressPrizePool}
          onPressSpots={onPressSpots}
          onPressWinner={onPressWinners}
        />
      </div>

      <div className="contestTab__contestList__container__web">
        {contestCategoryList.map((contest: any, idx: any) => {
          const { header, data } = contest;
          return (
            <div
              key={idx}
              style={{
                backgroundColor: 'rgb(255,255,255,5%)',
                marginTop: '40px',
                padding: '10px',
                marginBottom: '40px'
              }}>
              <View key={header.id}>
                <ContestListHeader
                  contestCategory={header}
                  key={header.id}
                  contestCount={header.contestCount}
                  onPressViewAll={showAllContest}
                />
              </View>

              <div
                className="contest_card_wrapper"
                key={idx}
                id={contest.header.id}
                style={{
                  gridTemplateColumns:
                    data.length <= 2
                      ? 'repeat(2, minmax(450px, 1fr))'
                      : `repeat(${Math.round((data.length + 1) / 2)}, minmax(450px, 1fr))`
                }}>
                {data.map((item: any, idx: any) => (
                  <React.Fragment key={idx}>
                    <ContestCardWeb
                      key={item._id}
                      contest={item}
                      onPressCard={() => onPressCard(item)}
                      onPressShare={() => onPressShare()}
                      matchStatus={matchStatus}
                      gameState={gameState}
                      totalTeamsCount={totalTeamsCount}
                      matchItem={matchItem}
                      screenName={'CONTEST_LIST'}
                      matchDelayed={matchDelayed}
                      gameType={gameType}
                      onPressJoin={() => onPressJoin(item)}
                    />
                  </React.Fragment>
                ))}
              </div>
            </div>
          );
        })}
        <ContestFilter
          onApplyFilter={onApplyFilter}
          onClearFilter={onClearFilter}
          visible={contestFilterVisible}
          onPressDismiss={onPressFilterDismiss}
        />
        <ContestShare
          link={contestLink}
          contestTitle={contestTitle}
          visible={contestShare}
          onPressDismiss={onPressShareModalDismiss}
        />
        <ContestConfirmModal
          visible={contestConfirmModal}
          onPressDismiss={onPressDismissContestConfirm}
          entryFee={entryFee / 100}
          selectedTeamCount={1}
          joinContest={onPressJoinContest}
          bonusPercentage={bonusPercentage}
        />
      </div>
      <AddCashModal
        totalAmount={balance['totalBalance']}
        visible={addCashVisible}
        onPressDismiss={onPressDismissCashModal}
      />
    </>
  );
};

export default ContestListTabWeb;
